import * as React from "react";
import { Field } from "redux-form";
import { FormSelectAutoCompleteComponent } from "../components";

class FormSelectAutoComplete extends React.Component<any, any> {
  public state = {
    data: [],
  };

  constructor(props: any) {
    super(props);
  }

  public componentWillReceiveProps(nextProps: any) {
    if (nextProps.data !== this.props.data) {
      const myData1 = nextProps.data.map((data: any, index: any) => {
        const value = data.id;

        return {
          ...data,
          label: this.getLabelValue(data),
          value,
        };
      });
      this.setState({ data: myData1 });
    }
  }

  public componentDidMount() {
    if (this.props.data) {
      const myData1 = this.props.data.map((data: any, index: any) => {
        const value = data.id;

        return {
          ...data,
          label: this.getLabelValue(data),
          value,
        };
      });
      this.setState({ data: myData1 });
    }
  }

  public render() {
    const {
      disabled,
      name,
      label,
      onChange,
      required,
      isMulti,
      onInputChange,
      menuIsOpen,
      validate,
    } = this.props;
    return (
      <Field
        value=""
        name={name}
        component={FormSelectAutoCompleteComponent}
        label={label}
        onChange={onChange}
        data={this.state.data}
        disabled={disabled}
        isMulti={isMulti}
        onInputChange={onInputChange}
        menuIsOpen={menuIsOpen}
        validate={validate}
        required={required}
      />
    );
  }

  /**
   * Function returning label value/text as per provided data
   */
  private getLabelValue = (data: any) => {
    if (data.userName) {
      return data.userName;
    } else {
      return data.name || data.description || data.countryName;
    }
  };
}

export default FormSelectAutoComplete;
